import ClosableCard from "@/components/closable-card";
import { LoginForm } from "@/components/login-form";
import { CardContent } from "@/components/ui/card";

export default function Login() {
  return (
    <ClosableCard className="relative" title="Login to your account">
      <CardContent>
        <LoginForm className="relative" />
      </CardContent>
    </ClosableCard>
  );
}
